module.exports = __webpack_public_path__ + "img/mil.51771270.svg";